var map = {
	"./contact_center/32x32_outline_hexagon.svg": "./app/javascript/assets/images/landings/contact_center/32x32_outline_hexagon.svg",
	"./contact_center/contact_center_logo_big.svg": "./app/javascript/assets/images/landings/contact_center/contact_center_logo_big.svg",
	"./contact_center/omnichannel_schema.svg": "./app/javascript/assets/images/landings/contact_center/omnichannel_schema.svg",
	"./contact_center/screens/kanban_board.svg": "./app/javascript/assets/images/landings/contact_center/screens/kanban_board.svg",
	"./contact_center/screens/nosco_omnichannel_inbox.png": "./app/javascript/assets/images/landings/contact_center/screens/nosco_omnichannel_inbox.png",
	"./contact_center/screens/nosco_omnichannel_inbox_small.png": "./app/javascript/assets/images/landings/contact_center/screens/nosco_omnichannel_inbox_small.png",
	"./contact_center/screens/ticket_timeline.png": "./app/javascript/assets/images/landings/contact_center/screens/ticket_timeline.png",
	"./hexagon_15deg.svg": "./app/javascript/assets/images/landings/hexagon_15deg.svg",
	"./iot/32x32_outline_hexagon.svg": "./app/javascript/assets/images/landings/iot/32x32_outline_hexagon.svg",
	"./iot/board.png": "./app/javascript/assets/images/landings/iot/board.png",
	"./iot/iot_logo_big.svg": "./app/javascript/assets/images/landings/iot/iot_logo_big.svg",
	"./iot/modelli_manutenzione.png": "./app/javascript/assets/images/landings/iot/modelli_manutenzione.png",
	"./iot/screens/dashboard_chart_resize.png": "./app/javascript/assets/images/landings/iot/screens/dashboard_chart_resize.png",
	"./iot/screens/dashboard_charts.png": "./app/javascript/assets/images/landings/iot/screens/dashboard_charts.png",
	"./iot/screens/events_chart.png": "./app/javascript/assets/images/landings/iot/screens/events_chart.png",
	"./iot/screens/portal.png": "./app/javascript/assets/images/landings/iot/screens/portal.png",
	"./iot/screens/softphone_incoming_call.png": "./app/javascript/assets/images/landings/iot/screens/softphone_incoming_call.png",
	"./kitchen/front_schermo.png": "./app/javascript/assets/images/landings/kitchen/front_schermo.png",
	"./kitchen/mano_sporca.jpg": "./app/javascript/assets/images/landings/kitchen/mano_sporca.jpg",
	"./workforce/32x32_outline_hexagon.svg": "./app/javascript/assets/images/landings/workforce/32x32_outline_hexagon.svg",
	"./workforce/screens/nosco_planner_saturation.png": "./app/javascript/assets/images/landings/workforce/screens/nosco_planner_saturation.png",
	"./workforce/screens/nosco_workforce_planner.png": "./app/javascript/assets/images/landings/workforce/screens/nosco_workforce_planner.png",
	"./workforce/screens/nosco_workforce_planner_small.png": "./app/javascript/assets/images/landings/workforce/screens/nosco_workforce_planner_small.png",
	"./workforce/screens/workforce_log_reminder.png": "./app/javascript/assets/images/landings/workforce/screens/workforce_log_reminder.png",
	"./workforce/screens/workforce_report_overview.png": "./app/javascript/assets/images/landings/workforce/screens/workforce_report_overview.png",
	"./workforce/workforce_logo_big.svg": "./app/javascript/assets/images/landings/workforce/workforce_logo_big.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./app/javascript/assets/images/landings sync recursive \\.(png|jpe?g|svg)$";